var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c("div", { staticClass: "boss-main-wrap" }, [
      _c("section", { staticClass: "boss-contractperiod-container" }, [
        _c("div", { staticClass: "boss-contractperiod-wrap" }, [
          _c("div", { staticClass: "boss-posting-container" }, [
            _c(
              "div",
              { staticClass: "boss-posting-wrap boss-main-content-wrap" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-layout boss-layout-vertical boss-layout-fill",
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "boss-page-title boss-page-title-layout-title pega-page-title",
                      },
                      [_vm._v("\n                除外者一覧\n              ")]
                    ),
                    _vm._v(" "),
                    _c("scout-members", {
                      attrs: {
                        "member-objects": _vm.memberObjects,
                        "display-key": "excluded",
                        "data-test": "scout-members",
                        count: _vm.count,
                        "count-limit": _vm.countLimit,
                      },
                      on: { fetch: _vm.fetch },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }